import { ComponentProps, FC } from 'react';

import CustomAsyncSelect from '../AsyncSelect/AsyncSelect';

const Autocomplete: FC<ComponentProps<typeof CustomAsyncSelect>> = (props) => {
  return <CustomAsyncSelect {...props} />;
};

export default Autocomplete;
